import { SxProps, Theme } from '@mui/material';

export const lowerFooterSx: SxProps<Theme> = (theme: Theme) => ({
	marginTop: '20px',
	display: 'flex',
	[theme.breakpoints.down('lg')]: {
		flexDirection: 'column',
		alignItems: 'center',
		gap: '20px',
	},
	[theme.breakpoints.up('lg')]: {
		flexDirection: 'row',
	},
});
